module.exports = __webpack_public_path__ + "fonts/manrope-600.cb7a8e9.woff2";